import React, {PropsWithChildren, useContext} from 'react';
import {AppContext} from "../context/appContext";
import {Navigate} from 'react-router';

interface Props {
    authenticated?: boolean;
    children: any;
}

export default function AppRoute(props: PropsWithChildren<Props>) {
    const context = useContext(AppContext);
    if (props.authenticated) {
        if (!context.userContext.user?.id.length) {
            return <Navigate to='/inloggen' replace/>;
        }
    }
    return props.children;
}